import ExtendedLandlordInformationContent from './ExtendedLandlordInformationContent';

export default ExtendedLandlordInformationContent;
